/** Auth email return URL (`/auth`). Uses `REACT_APP_SITE_URL` when set so preview hosts are not baked into emails. */

/** Canonical site origin for auth emails and Universal Link targets. */
export function getSiteOrigin(): string {
  const fromEnv = process.env.REACT_APP_SITE_URL?.trim().replace(/\/$/, '');
  if (fromEnv) return fromEnv;
  if (typeof window !== 'undefined') return window.location.origin;
  return 'https://bravosfit.com';
}

function authBaseUrl(): string {
  const origin = getSiteOrigin();
  return origin ? `${origin}/auth` : '';
}

/** Absolute dashboard URL after signup confirm — real navigation so iOS Universal Links can open the app. */
export function getPostConfirmDashboardUrl(role: string | null | undefined): string {
  const path = role === 'trainer' ? '/trainer-dashboard' : '/member-dashboard';
  return `${getSiteOrigin()}${path}`;
}

/** Signup confirmation / resend — `/auth` (existing allow-listed URL). */
export function getSignupConfirmRedirectUrl(): string {
  return authBaseUrl();
}

/**
 * Password-reset emails must land on the set-new-password view.
 * `type=recovery` is a query param so it survives `detectSessionInUrl` clearing the hash,
 * and so iOS Universal Links (which drop fragments) still know this is a reset.
 */
export function getPasswordResetRedirectUrl(): string {
  return `${authBaseUrl()}?type=recovery`;
}
